




















































































































































































































import { defineComponent, reactive, toRefs, onMounted, ref } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import AlertArea from "../../components/AlertArea.vue"
import MasterMainteTab from "../../components/MasterMainteTab.vue"
import CustomConfirmModal from "../../components/CustomConfirmModal.vue"
import { BTable, BModal } from 'bootstrap-vue';
import { SearchCondition, CopyBaseSheetSearchCondition, BaseSheet } from "../../modules/teacher/ApprovalBaseSheetList"

export interface Data {
  condition: SearchCondition
  copyBaseSheetCondition: CopyBaseSheetSearchCondition
  baseSheets: BaseSheet[]
  copyModalBaseSheets: BaseSheet[]
  dstBaseSheet: BaseSheet
  srcBaseSheet: BaseSheet
  fields: any[]
  copyFields: any[]
  perPage: number
  isAllDeleteChecked: boolean
  isShow: boolean
  errors: string[]
}

export default defineComponent({
  components: {
    "master-mainte-tab": MasterMainteTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    const tableRef = ref<InstanceType<typeof BTable>>();
    const modalBaseSheetListRef = ref<InstanceType<typeof BModal>>();
    const customConfirmModalRef = ref<InstanceType<typeof CustomConfirmModal>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      condition: context.root.$store.state.approvalBaseSheetListCondition,
      copyBaseSheetCondition: new CopyBaseSheetSearchCondition(),
      baseSheets: new Array<BaseSheet>(),
      copyModalBaseSheets: new Array<BaseSheet>(),
      dstBaseSheet: null,
      srcBaseSheet: null,
      fields: [
        {key: "sheet_code", label: "試験ID", sortable: true, class: 'text-center b-table-th-td'},
        {key: "nendo", label: "年度", sortable: true, class: 'text-center b-table-th-td'},
        {key: "subject_name", label: "科目", sortable: true, class: 'text-center b-table-th-td'},
        {key: "sheet_type", label: "試験種別", sortable: true, class: 'text-center b-table-th-td'},
        {key: "report_no", label: "回次", sortable: true, class: 'text-center b-table-th-td'},
        {key: "name", label: "試験名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "qr_code", label: "QRコード", sortable: true, class: 'text-center b-table-th-td'},
        {key: "field_names_completed_text", label: "設問情報", class: 'text-center b-table-th-td'},
        {key: "corretct_image_completed_text", label: "模範解答", class: 'text-center b-table-th-td'},
        {key: "field_positions_completed_text", label: "設問枠", class: 'text-center b-table-th-td'},
        {key: "score_positions_completed_text", label: "得点枠", class: 'text-center b-table-th-td'},
        {key: "is_completed", label: "定義状態", class: 'text-center b-table-th-td'},
        {key: "edit", label: "設定", class: 'text-center b-table-th-td'},
        {key: "copy", label: "コピー", class: 'text-center b-table-th-td'},
        {key: "delete", label: "削除", class: 'text-center'},
      ],
      copyFields: [
        {key: "sheet_code", label: "試験ID", sortable: true, class: 'text-center b-table-th-td'},
        {key: "nendo", label: "年度", sortable: true, class: 'text-center b-table-th-td'},
        {key: "subject_name", label: "科目", sortable: true, class: 'text-center b-table-th-td'},
        {key: "sheet_type", label: "試験種別", sortable: true, class: 'text-center b-table-th-td'},
        {key: "report_no", label: "回次", sortable: true, class: 'text-center b-table-th-td'},
        {key: "name", label: "試験名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "copy", label: "コピー", class: 'text-center b-table-th-td'},
      ],
      perPage: 20,
      isAllDeleteChecked: false,
      isShow: false,
      errors: [],
    });

    /******************************
     * 検索ボタン押下
     ******************************/

    const searchClick = () => {
      state.condition.currentPage = 1;
      search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      
      state.errors = []
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/approval_base_sheet_list?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.baseSheets = response.data.base_sheet_hashes.map((x: any) => new BaseSheet(x)); 
        context.root.$store.commit("setApprovalBaseSheetListCondition", state.condition);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    /******************************
     * 採点設定画面へ
     ******************************/

    const saitenSettingClick = (baseSheet: BaseSheet) => {
      // 採点設定の進捗により遷移先を制御
      if (!baseSheet.field_names_completed) {
        context.root.$router.push(`/teacher_site/field_edit/${baseSheet.id}`).catch(err => {});
        return;
      }
      if (!baseSheet.corretct_image_completed) {
        context.root.$router.push(`/teacher_site/correct_image_upload/${baseSheet.id}`).catch(err => {});
        return;
      }
      if (!baseSheet.field_positions_completed) {
        context.root.$router.push(`/teacher_site/position_edit/${baseSheet.id}`).catch(err => {});
        return;
      }
      context.root.$router.push(`/teacher_site/score_position_edit/${baseSheet.id}`).catch(err => {});
    };

    /******************************
     * 試験削除
     ******************************/

    const deletebaseSheets = async (): Promise<void> => {

      state.errors = [];

      const delete_ids: number[] = state.baseSheets.filter(x => x.is_checked).map(x => x.id);

      if(delete_ids.length == 0){
        alert("削除対象試験が選択されていません。");
        return;
      }

      let is_exists_sheet = false;

      // 提出済み試験有無を検索
      await http.post(`/api/teacher/approval_base_sheet_list/is_exists_sheet`, {ids: delete_ids}).then(response => {
        is_exists_sheet = response.data.is_exists_sheet;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      if(is_exists_sheet){
        alert("既に提出済み答案が存在する試験は削除できません。");
        return;
      }

      if(!window.confirm("選択している試験を削除します。よろしいですか？")){
        return;
      }
      
      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/teacher/approval_base_sheet_list/delete_base_sheets`, {ids: delete_ids}).then(response => {
        alert(`削除処理が完了しました。`);
        search();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * ページ内の試験全件選択
     ******************************/

    const allSelectChanged = (isChecked: boolean) => {
      tableRef.value.computedItems.forEach((x: BaseSheet) => x.is_checked = isChecked);
    };

    /******************************
     * ページ切り替え
     ******************************/

    const pageChanged = () => {
      state.isAllDeleteChecked = false;
      state.baseSheets.forEach(x => x.is_checked = false);
    };

    /******************************
     * 一括アップロード画面へ
     ******************************/

    const toIkkatuUpload = (url: string) => {
      context.root.$router.push(url);
    }

    /******************************
     * コピーモーダル表示
     ******************************/

     const showCopyBaseSheetModal = async (baseSheet: BaseSheet) => {
      state.dstBaseSheet = baseSheet;

      let is_exists_sheet = false;

      // 提出済みレポート有無を検索
      await http.post(`/api/teacher/approval_base_sheet_list/is_exists_sheet`, {ids: [state.dstBaseSheet.id]}).then(response => {
        is_exists_sheet = response.data.is_exists_sheet;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      if(is_exists_sheet){
        alert(`「${state.dstBaseSheet.name}」は既に提出済みの答案が存在するためコピー機能は使用できません。`);
      }else{
        modalBaseSheetListRef.value.show();
      }
    }

    /******************************
    * コピー検索条件クリア
    ******************************/

    const clearCopyBaseSheetCondition = () => {
      state.copyBaseSheetCondition = new CopyBaseSheetSearchCondition();
    };

    /******************************
    * コピー検索ボタン押下
    ******************************/

    const searchCopyBaseSheetClick = () => {
      state.copyBaseSheetCondition.currentPage = 1;
      searchCopyBaseSheet();
    };

    /******************************
    * コピー検索API
    ******************************/

    const searchCopyBaseSheet = async () => {
    
      state.copyBaseSheetCondition.dst_base_sheet_id = state.dstBaseSheet.id;
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/approval_base_sheet_list/search_copy_base_sheets?${Common.BuildQuery(state.copyBaseSheetCondition, 'copy_base_sheet_search_condition')}`).then(response => {
        state.copyModalBaseSheets = response.data.base_sheets.map((x: any) => new BaseSheet(x)); 
        context.root.$store.commit("setCopyApprovalBaseSheetCondition", state.condition);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * コピーボタンクリック
     ************************************************************/

    const copyClick = async (srcBaseSheet: BaseSheet) => {
      
      state.errors = [];

      let is_exists_sheet = false;

      // 提出済みレポート有無を検索
      await http.post(`/api/teacher/approval_base_sheet_list/is_exists_sheet`, {ids: [state.dstBaseSheet.id]}).then(response => {
        is_exists_sheet = response.data.is_exists_sheet;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      if(is_exists_sheet){
        alert(`「${state.dstBaseSheet.name}」は既に提出済みの答案が存在するためコピー機能は使用できません。`);
        return;
      }else{
        state.srcBaseSheet = srcBaseSheet;
        customConfirmModalRef.value.show();
      }
    }

    /************************************************************
     * コピー実行
     ************************************************************/

    const copyBaseSheet = async () => {

      customConfirmModalRef.value.hide();
      modalBaseSheetListRef.value.hide();
      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/approval_base_sheet_list/copy_base_sheet/${state.dstBaseSheet.id}/${state.srcBaseSheet.id}`).then(async response => {
        alert("処理が完了しました。");
        const idx = state.baseSheets.indexOf(state.dstBaseSheet);
        state.baseSheets.splice(idx, 1, new BaseSheet(response.data.base_sheet));
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      // 試験マスタ管理を試験系の採点設定フローとして初期化
      context.root.$store.commit("setSheetType", Common.SheetTypeEnum.ApprovalExam);
      await search();
      state.isShow = true;
    });

    return {
      ...toRefs(state),
      tableRef,
      modalBaseSheetListRef,
      customConfirmModalRef,
      searchClick,
      search,
      clearCondition,
      saitenSettingClick,
      deletebaseSheets,
      allSelectChanged,
      pageChanged,
      toIkkatuUpload,
      showCopyBaseSheetModal,
      clearCopyBaseSheetCondition,
      searchCopyBaseSheetClick,
      copyClick,
      copyBaseSheet,
      SheetTypeEnum: Common.SheetTypeEnum,
      getSheetTypeName: Common.getSheetTypeName,
    };
  }
});
